import { fontStyles, LoadingIndicator } from '@monash/portal-react';
import { capitaliseAllWords } from '@monash/portal-frontend-common';
import React, { useContext } from 'react';
import Card from '../../ui/card/Card';

import { StudentContext } from '../../providers/StudentProvider';
import { transformAddress } from './utils';
import TextBlock from './text-block/TextBlock';
import c from './contact.module.scss';
import PageContainer from '../../ui/page-container/PageContainer';

const Contact = () => {
  const { profileData, loadingProfileData } = useContext(StudentContext);
  const emergencyContacts = Array.isArray(profileData?.emergencyContacts)
    ? profileData?.emergencyContacts
    : [];

  const { homeAddress, postalAddress, mobilePhoneNumber, homePhoneNumber } =
    profileData || {};

  const hasMultipleEmergencyContacts = emergencyContacts.length > 1;

  if (loadingProfileData) {
    return (
      <div className={c.loadingWrapper}>
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <PageContainer>
      <div className={c.contactWrapper} role="region" aria-label="Contact">
        <div className={c.rows}>
          <h1 className={fontStyles.heading}>Contact</h1>

          <div className={c.columns}>
            {transformAddress(homeAddress) && (
              <Card>
                <TextBlock
                  label="Home address"
                  value={transformAddress(homeAddress)}
                />
              </Card>
            )}

            {transformAddress(postalAddress) && (
              <Card>
                <TextBlock
                  label="Postal address"
                  value={transformAddress(postalAddress)}
                />
              </Card>
            )}
          </div>

          {postalAddress?.attentionName && (
            <Card>
              <TextBlock
                label="Mailing name format"
                value={postalAddress?.attentionName}
              />
            </Card>
          )}

          <div className={c.columns}>
            {mobilePhoneNumber && (
              <Card>
                <TextBlock
                  label="Mobile phone number"
                  value={mobilePhoneNumber}
                />
              </Card>
            )}

            {homePhoneNumber && (
              <Card>
                <TextBlock label="Home phone number" value={homePhoneNumber} />
              </Card>
            )}
          </div>
        </div>
        {Boolean(emergencyContacts.length) && (
          <div className={c.rows} role="region" aria-label="Emergency contacts">
            <h2 className={fontStyles.md}>Emergency contacts</h2>

            <div
              className={
                hasMultipleEmergencyContacts && c.emergencyContactsGrid
              }
            >
              {emergencyContacts.map((contact) => (
                <Card key={contact.preferredName}>
                  <div className={c.rows}>
                    <TextBlock
                      label="Name"
                      value={
                        contact.preferredName
                          ? capitaliseAllWords(contact.preferredName)
                          : '-'
                      }
                      smallGap
                    />

                    <TextBlock
                      label="Phone number(s)"
                      value={contact.phone.map(({ phoneNumber }) => {
                        return (
                          <div className={c.phoneNumbers} key={phoneNumber}>
                            <div>{phoneNumber}</div>
                          </div>
                        );
                      })}
                      smallGap
                    />

                    <TextBlock
                      label="Relationship"
                      value={capitaliseAllWords(
                        contact.additionalDetails.relationship
                      )}
                      smallGap
                    />

                    {contact.address.map((item, index) => {
                      const needsNumbers = contact.address.length > 1;
                      const label = needsNumbers
                        ? `Address ${index + 1}`
                        : 'Address';

                      return (
                        <TextBlock
                          key={item.addressLine1}
                          label={label}
                          value={transformAddress(item) || '-'}
                          smallGap
                        />
                      );
                    })}
                  </div>
                </Card>
              ))}
            </div>
          </div>
        )}
      </div>
    </PageContainer>
  );
};

export default Contact;
